import {Component, input} from '@angular/core';
import {NguCarousel} from '@ngu/carousel';
import {CircleIconComponent} from '@core/svg-icons/circle-icon.component';

@Component({
  selector: 'app-carousel-point',
  templateUrl: './carousel-point.component.html',
  imports: [
    CircleIconComponent,
  ],
  styleUrl: './carousel-point.component.scss'
})
export class CarouselPointComponent {
  carousel = input.required<NguCarousel<any, any>>()
}
